/**
 * Append a single GET key-value pair to url, ensuring proper url structure.
 * @param {string} url
 * @param {string} key
 * @param {any} value
 */
export function appendGetParam(url, key, value) {
  const urlParts = url.split('#');
  const prefix = urlParts[0].indexOf('?') !== -1 ? '&' : '?';
  urlParts[0] += `${prefix}${key}=${value}`;
  return urlParts.length > 1 ? urlParts.join('#') : urlParts[0];
}

/**
 * Append multiple GET key-value pairs to url, ensuring proper url structure.
 *    params: object holding key-value pairs to append
 */
export function appendGetParams(url, params) {
  if (!url) {
    return null;
  }
  const urlParts = url.split('#');
  let delimiter = urlParts[0].indexOf('?') !== -1 ? '&' : '?';
  Object.keys(params).forEach(key => {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      urlParts[0] += `${delimiter}${key}=${params[key]}`;
      delimiter = '&';
    }
  });

  return urlParts.length > 1 ? urlParts.join('#') : urlParts[0];
}

/**
 * Convert get params to object
 * '?a=1&b=2' -> {a:1, b:2}
 * @param {String} [paramStr] - GET-param-formatted string (optional)
 * @return {Object}
 */
export function getParamsObject(paramStr = window.location.search) {
  const getparamsArray = paramStr.replace('?', '').split('&');
  const getparams = {};
  getparamsArray.forEach(param => {
    if (param.length > 0) {
      const [key, value] = param.split('=');
      getparams[key] = value;
    }
  });

  return getparams;
}
